import { ReactNode } from "react";
import { IKeyValuePair, IKeyValuePairLazy } from "../../interfaces-and-types";
import { View } from "./View";

interface ISummaryTableData extends IKeyValuePairLazy {
  link_url: string;
}

export interface ISummaryTableProps {
  Title: string;
  data: ISummaryTableData[];
  navigateToRoute: (route: string) => void;
  renderRow?: (val: IKeyValuePairLazy, index: number) => ReactNode;
}

export const SummaryTable = (props: ISummaryTableProps) => {
  return <View {...props} />;
};
